import styled from 'styled-components';
const UBISOFT_BLUE = '#428ee0'
const TABLET_BREAKPOINT = '1475px';
const MIN_TABLET_BREAKPOINT = '850px';
const SELECTORS = ', .pt_content #primary'

interface INavigationStyle {
  isCurrentPage: boolean;
  isLastItem:boolean;
}

export const Navigation = styled.div`
    ${SELECTORS} & {
      padding-top: 50px;
    }
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
       ${SELECTORS} & {
         padding-top: 0;
       }
   }
`;

export const NavigationContainer = styled.div`
    ${SELECTORS} & {
      width: 80%;
      max-width: 1380px;
      margin: 0 auto 70px auto;
       height: 80px;
      background-color: #3C4145;
      border-radius: 15px;
      display: flex;
      flex-wrap: wrap;
     
      justify-content: space-between;
      align-content: center;
    }
    svg{
        display: block;
        width: 175px;
        height: 28px;
        margin: auto 0 auto 30px;
         
    } 
   @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
          height: 60px;
          justify-content: unset;
          align-content: unset;
        }
        svg{
          height: 20px;
          width: 87.5px;
        }
   }
   @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
       ${SELECTORS} & {
         width: 100%;
         border-radius: 0;
         overflow: auto;
         white-space: nowrap;
         margin-top: 0;
         margin-bottom: 0;
         .navigation-logo{
            display: none;
         }
       }
   }
   
`;

export const NavigationLineSeparator = styled.div`
    ${SELECTORS} & {
        height: 65%;
        width: 4px;
        background-color: white;
        margin: auto 50px;
    }
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
        ${SELECTORS} & {
            display: none;   
        }
    }
`;

export const NavigationItemsContainer = styled.div`
    ${SELECTORS} & {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
      ${SELECTORS} & {
          margin: auto;
       }
    }
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
        ${SELECTORS} & {
          margin: auto 0;
          overflow-x: scroll;
          overflow-y: hidden;
          display: block;   
        }
    }
`;

export const NavigationItem = styled.a`
    ${SELECTORS} & {
      position: relative;
        font-size: 18px;
        text-decoration: none;
        font-style: normal;
        line-height: 25px;
        text-align: center;
        text-transform: uppercase;
        margin: auto ${({ isLastItem }: INavigationStyle) => (isLastItem ? '0' : '60px')} auto 0px;
    }
    
    color : ${({ isCurrentPage }: INavigationStyle) => isCurrentPage ? UBISOFT_BLUE : 'white'} !important ;
    
    &:hover {
       color: ${UBISOFT_BLUE} !important ;
    }
    
    ${({ isCurrentPage }: INavigationStyle) => isCurrentPage ? `
        &:before {
        content: '';
        position: absolute;
        right: -30px;
        bottom: -27px;
        left: -30px;
        border-bottom: 4px solid ${UBISOFT_BLUE};
        width: 100%;
        margin: auto;
    }
    ` : ''};
    @media (min-width: ${MIN_TABLET_BREAKPOINT}) { 
      &:hover {
           &:before {
            content: '';
            position: absolute;
            right: -30px;
            bottom: -27px;
            left: -30px;
            width: 100%;
            border-bottom: 4px solid ${UBISOFT_BLUE};
            margin: auto;
        }
      }
    }
    
     @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
          font-size: 16px;
          margin: auto 20px auto 0;
          &:before {
            bottom: -16px !important;
          }
        }
    }
    
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
          ${SELECTORS} & {
              margin: auto 10px auto 10px;
              
          }
    }
`;

export const NavigationSubscriptionButton = styled.div`
   ${SELECTORS} & {
        margin: auto 30px auto 0;
   }
   @media (max-width: ${TABLET_BREAKPOINT}) {
        display: none;
    }
`;